import React, {useMemo} from "react";
import useThemeColors from "../organization/portal/useThemeColors";
import {alphaFromHex} from "../../util/colors";
import useTranslation from "../../i18n/useTranslation";

export default function MarketplaceListingCardList({
    title,
    subtitle,
    items,
    loading,
    onAdd,
    addButtonTitle,
    filter,
    renderItem,
    emptyText,
    pagination,
    onPageChange,
}) {
    const {t} = useTranslation();
    const colors = useThemeColors();
    const safeItems = useMemo(() => Array.isArray(items) ? items : [], [items]);

    return (
        <div className="marketplace-listing-panel" style={{
            borderRadius: 18,
            overflow: "hidden",
            border: `1px solid ${alphaFromHex(colors.primary, 0.18)}`,
            background: colors.lightSurface || "#fff",
            boxShadow: "0 18px 44px rgba(0,0,0,0.10)",
        }}>
            <div className="d-flex flex-wrap align-items-center justify-content-between" style={{gap: 14, padding: "14px 16px", background: `linear-gradient(135deg, ${alphaFromHex(colors.primary, 0.28)}, ${alphaFromHex(colors.primary, 0.04)})`, borderBottom: `1px solid ${alphaFromHex(colors.primary, 0.14)}`}}>
                <div className="d-flex align-items-center" style={{gap: 10, minWidth: 0}}>
                    <span style={{display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: "50%", background: colors.primary, color: colors.textOnPrimary, fontWeight: 900}}>{safeItems.length}</span>
                    <div style={{minWidth: 0}}>
                        <h3 className="mb-1 text-truncate" style={{fontSize: 15, fontWeight: 900, color: colors.textOnPrimary}} title={title}>{title}</h3>
                        <p className="mb-0" style={{fontSize: 12.5, fontWeight: 700, color: colors.textOnPrimary}}>{subtitle || t("marketplacePage.catalogSubtitle")}</p>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-wrap" style={{gap: 10}}>
                    {onAdd ? <button type="button" className="btn" onClick={onAdd} style={{borderRadius: 12, padding: "10px 12px", fontWeight: 900, background: colors.primary, color: colors.textOnPrimary, border: `1px solid ${alphaFromHex(colors.primary, 0.25)}`}}><i className="fas fa-plus mr-2" />{addButtonTitle || t("marketplaceManagementPage.createListing")}</button> : null}
                </div>
            </div>

            {filter ? <div className="d-flex flex-wrap align-items-center justify-content-between" style={{gap: 12, padding: "12px 18px", background: colors.lightSurface || "#fff", borderBottom: `1px solid ${alphaFromHex(colors.primary, 0.12)}`}}>
                <div className="small text-muted font-weight-bold"><i className="fas fa-sliders-h mr-2" style={{color: colors.primary}} />{t("marketplaceManagementPage.statusFilter")}</div>
                <div>{filter}</div>
            </div> : null}

            <div style={{padding: 18, minHeight: 150}}>
                {loading ? <div className="text-center text-muted py-5"><span className="spinner-border spinner-border-sm mr-2" role="status" />{t("common.loading")}</div> : null}
                {!loading && !safeItems.length ? <div className="text-center text-muted py-5" style={{borderRadius: 14, border: `1px solid ${alphaFromHex(colors.primary, 0.12)}`, background: alphaFromHex(colors.primary, 0.03), fontWeight: 800}}>{emptyText || t("marketplacePage.noListings")}</div> : null}
                {!loading && safeItems.length ? <div className="row" style={{rowGap: 18}}>{safeItems.map(renderItem)}</div> : null}
            </div>

            {pagination?.pages > 1 && onPageChange ? <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "0 18px 18px"}}>
                <button
                    type="button"
                    style={{borderRadius: 12, padding: "10px 12px", fontWeight: 900, border: "1px solid rgba(0,0,0,0.12)", background: "#fff", color: "#14151a", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8, opacity: pagination.hasPrev ? 1 : 0.5}}
                    onClick={() => pagination.hasPrev && onPageChange(pagination.page - 1)}
                    disabled={!pagination.hasPrev || loading}
                    title={t("common.table.prev")}
                >
                    <i className="fas fa-arrow-left" />
                    {t("common.table.prev")}
                </button>
                <div style={{fontWeight: 900, fontSize: 12.5, color: "rgba(20,21,26,0.70)", whiteSpace: "nowrap"}}>
                    {t("common.table.page")} {pagination.page} {t("common.table.of")} {pagination.pages}
                </div>
                <button
                    type="button"
                    style={{borderRadius: 12, padding: "10px 12px", fontWeight: 900, border: "1px solid rgba(0,0,0,0.12)", background: "#fff", color: "#14151a", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8, opacity: pagination.hasNext ? 1 : 0.5}}
                    onClick={() => pagination.hasNext && onPageChange(pagination.page + 1)}
                    disabled={!pagination.hasNext || loading}
                    title={t("common.table.next")}
                >
                    {t("common.table.next")}
                    <i className="fas fa-arrow-right" />
                </button>
            </div> : null}
        </div>
    );
}
